import React, { useState } from 'react'
import { muiWithStyles, MuiGrid, MuiTypography, MuiInfoIcon, MuiTextField, MuiDialogActions, MuiDialogContent, MuiDialogTitle, MuiButton, MuiDialog } from '../../../ui/MaterialUIComponents';
import theme from '../../../../assests/theme'
import { ScheduleConstants } from './ScheduleConstants';
import * as Constants from '../../../../constants';
import * as StringReplacer from '../../../../i18n/StringReplacer'
import {saveSchoolConcurrently} from '../../../../utils/ConcurrentSchoolSaveUtil';
import { toast } from "react-toastify";
function CreateScheduleDialog(props) {
    const [scheduleName, setScheduleName] = useState("");
    const [error, setError] = React.useState(false);
    const [textEditFlag, setTextEditFlag] = React.useState(false);

    const [errors, setErrors] = useState("")
    const saveScheduleOnKeyPress = async (event) => {
        if (event.keyCode === Constants.KEY_RETURN ) {
            
            if(props.type=='create'){
                await onClickCreateSchedule()
            }
           else{
                await editScheduleName();
           }
        }

    }
    const editScheduleName = async(event) => {
       
            if (validation(scheduleName)) {
                props.schedule.name = scheduleName;
                
                await props.editSchedule(props.schedule)
            }
        
    }

    function validation(scheduleName) {
        if (scheduleName !== '') {
            if (props.activeSchool.schedule_constraints !== undefined && props.activeSchool.schedule_constraints.length !== 0) {
                let schedule_constraints = props.activeSchool.schedule_constraints
                schedule_constraints = schedule_constraints.filter(function (schedule_constraint) {
                    return schedule_constraint.name === scheduleName
                })

                if (schedule_constraints.length >= 1) {
                    //setScheduleName(tempScheduleName)
                    toast(StringReplacer.getFormatedMessage(i18n.schedule.uniqueScheduleName, { ScheduleName: scheduleName }));
                    return false
                }
            }
        }
        else {
            //setScheduleName(tempScheduleName)
            toast(i18n.schedule.createScheduleErrorText);
            return false
        }
        return true
    }
    const onClickCreateSchedule = async () => {

        if (validation(scheduleName)) {
            if (scheduleName != '') {
                let scheduleObject = {}
                scheduleObject.weeklyCalendar = []
                if (props.scheduleObj != undefined) {
                    scheduleObject = props.scheduleObj
                }
                scheduleObject.name = scheduleName
                scheduleObject.createdBy = props.userInformation['_id']
                scheduleObject.createdDate = new Date()
                scheduleObject.status = ScheduleConstants.INPROGRESS
                scheduleObject.assignedData = []
                let activeSchool = props.activeSchool;
                activeSchool.schedule_constraints.push(scheduleObject)
                //  activeSchool.schedule_constraints = []
               // activeSchool = await props.editSchoolInformation(props.userInformation._id, props.activeSchool._id, activeSchool)

               
                let result = await saveSchoolConcurrently(props.editSchoolInformation,
                    props.userInformation._id,
                    props.activeSchool._id,
                    activeSchool, i18n.schedule.creationOfScheduleSucessToast);
                if(result.success){
                    activeSchool = result.updatedSchool;
                    props.activeSchool.schedule_constraints = activeSchool.schedule_constraints
                    // await props.toggleCreateScheduleDialogMethod();
                    await props.updateList();
                    await props.toggleToAddNewRules();
                   // props.history.push('/addNewRules')
                }else{
                    setError(prevOpen => !prevOpen);
                    //activeSchool.schedule_constraints.pop();
                    //props.activeSchool.schedule_constraints = activeSchool.schedule_constraints
                    //await props.toggleCreateScheduleDialogMethod();
                    //await props.updateList();
                }
                
            } else {
                setError(prevOpen => !prevOpen);
            }
        }

    }

    function validation(scheduleName) {
        if (scheduleName !== '') {
            if (props.activeSchool.schedule_constraints !== undefined && props.activeSchool.schedule_constraints.length !== 0) {
                let schedule_constraints = props.activeSchool.schedule_constraints
                schedule_constraints = schedule_constraints.filter(function (schedule_constraint) {
                    return schedule_constraint.name === scheduleName
                })
                if (schedule_constraints.length === 1) {
                    setErrors(StringReplacer.getFormatedMessage(i18n.schedule.uniqueScheduleName, { ScheduleName: scheduleName }))
                    return false
                }
            }
        }
        else {
            setErrors(i18n.schedule.createScheduleErrorText)
            return false
        }
        return true
    }
    function handleChange(e) {
        setScheduleName(e.target.value)
        setTextEditFlag(true);

    }

    const { classes, i18n } = props;  
    return (
        <MuiDialog
            open={props.open}
            onClose={() => props.toggleCreateScheduleDialogMethod()}
            style={{ width: '100vw' }}
            disableBackdropClick={true}
        >

            <MuiDialogTitle style={{ background: theme.palette.grey.dark }} >
                <MuiGrid container>
                    <MuiGrid item xs container alignItems="center" justify="center" >
                        <MuiTypography style={{ fontFamily: "Arial", fontSize: '15px', color: "white" }}>
                            {props.title}
                        </MuiTypography>
                    </MuiGrid>

                    <MuiGrid item container alignItems="center" justify="center" xs={1} >
                        <MuiButton >
                            <MuiInfoIcon style={{ color: "white" }} size="small" />
                        </MuiButton>
                    </MuiGrid>
                </MuiGrid>
            </MuiDialogTitle>

            <MuiDialogContent>
                <MuiGrid container direction='column' alignContent="center" justify="center" xs={11} style={{ padding: 5 }} >
                    <MuiGrid item xs={12}>

                        <MuiTypography variant="body2">
                            {props.description}
                        </MuiTypography>
                    </MuiGrid>
                    <MuiGrid item xs={12}>

                        <MuiTextField

                            variant='outlined'
                            id='filterList'
                            autoFocus
                            onChange={e => handleChange(e)}
                            style={{ width: '25vw' }}
                            placeholder={i18n.schedule.createScheduleTextFieldPlaceHolder}
                            value={props.schedule!=undefined?scheduleName=='' && textEditFlag==false?props.schedule.name:scheduleName:scheduleName}
                            color='primary'
                            label={i18n.schedule.createScheduleTextFieldLabel}
                            margin='normal'
                            onKeyDown={(event) => saveScheduleOnKeyPress(event)}

                        />
                    </MuiGrid>
                    {<MuiGrid item xs={12} style={{ width: '100%' }} align='left' >
                        <MuiTypography variant={theme.typographyStyles.CAPTION} color='error'>{errors}</MuiTypography>
                    </MuiGrid>}
                </MuiGrid>
            </MuiDialogContent>

            <MuiDialogActions>
                <MuiGrid container spacing={2} align="center" justify='flex-end'>

                    <MuiGrid item>
                        <MuiButton

                            style={theme.secondaryButtonStyle}
                            onClick={
                                props.toggleCreateScheduleDialogMethod
                            }>
                            {i18n.commonTexts.cancel}
                        </MuiButton>
                    </MuiGrid>
                    <MuiGrid item >
                        <MuiButton
                            style={theme.primaryButtonStyle}

                            onClick={props.type == 'create' ? onClickCreateSchedule:editScheduleName}
                        >
                            {props.type == 'create' ? i18n.commonTexts.create : i18n.commonTexts.update}
                        </MuiButton>
                    </MuiGrid>

                </MuiGrid>
            </MuiDialogActions>

        </MuiDialog>
    )


}
const elementClassNames = theme => ({

    deleteButton: {
        width: "117px",
        borderRadius: "30px",
        textTransform: "none",
        backgroundColor: theme.palette.primary, color: theme.palette.textPrimary,
        [theme.breakpoints.down('xs')]: { width: "150px" }
    },

    cancelButton: {
        width: "117px",
        borderRadius: "30px",
        textTransform: "none",
        border: `1px solid ${theme.palette.secondary[300]}`,
        [theme.breakpoints.down('xs')]: { width: "150px" }
    },
    dialogActionGrid: { height: "5vh" },

})
export default muiWithStyles(elementClassNames)(CreateScheduleDialog);